<script setup lang="ts">
import { computed, onMounted, ref, toRefs, watch } from 'vue';
import LazyImage from '../LazyImage.vue';
import { useScreenSize } from '../../core';
import Carousel from '../carousel/BaseCarousel.vue';
import { NextIconHtml, PrevIconHtml } from '../../constant/icons';
import CustomCarousel from './CustomCarousel.vue';

const props = defineProps<{
  sliderData: any[];
  currentSlide: number;
}>();
const { sliderData, currentSlide } = toRefs(props);
const timelineCarouselConfig = computed(() => {
  return {
    settings: {
      itemsToShow: isLg.value ? 12 : 4,
    },
    slides: sliderData.value,
    slidesForNavigation: 1,
  };
});

const carouselConfig = computed(() => {
  return {
    settings: {
      itemsToShow: 1,
    },
    slides: sliderData.value,
    navigationActive: true,
    slidesForNavigation: 1,
    nextIconHtml: NextIconHtml,
    previousIconHtml: PrevIconHtml,
  };
});

const { isLg } = useScreenSize();
const selectedSlide = ref(0);

const setSlide = (index: number) => {
  selectedSlide.value = index;
};

watch(currentSlide, () => {
  setSlide(currentSlide.value);
});

const setSlideIndex = (item) => {
  const index = sliderData.value.findIndex(
    (data) => data.asset_value === item.asset_value
  );
  setSlide(index);
};

onMounted(() => {
  setSlide(currentSlide.value);
});
</script>
<template>
  <div>
    <CustomCarousel
      v-bind="carouselConfig"
      ref="custom-carousel"
      :selected-slide="selectedSlide"
      @update:current-slide="(slideIndex) => setSlide(slideIndex)"
    >
      <template #main-slide="{ item, index }">
        <div
          class="carousel__item disabled-image-pointer"
          @click="setSlide(index)"
        >
          <p
            v-if="item?.caption"
            class="desktop-body-l text-white-light py-2 mb-8 text-left"
          >
            {{ item?.caption }}
          </p>
           <LazyImage
              v-if="item?.asset_value"
              class="aspect-video"
              :src="item.asset_value"
              :alt="item.alt_tag"
              :is-neighborhood-image="false"
            />

        </div>
      </template>
    </CustomCarousel>
    <Carousel
      v-bind="timelineCarouselConfig"
      :selected-slide="selectedSlide"
      :delay-in-transition="1000"
      class="masonry-thumbnail"
      :class="{ notranslate: timelineCarouselConfig.slides.length < 11 }"
    >
      <template #default="{ item }">
        <div
          class="carousel__item h-12 md:h-20 w-full rounded overflow-hidden px-1"
          :class="{ 'border-white-light': item.index === selectedSlide }"
          @click="setSlideIndex(item)"
        >
          <div class="w-full h-full">

            <LazyImage
             v-if="item && item?.asset_value"
              class="h-full w-full object-cover rounded"
              :src="item.asset_value + '?io=transform:fill,width:200'"
              :alt="item.alt_tag"
              :is-neighborhood-image="false"
            />
          </div>
        </div>
      </template>
    </Carousel>
  </div>
</template>

<style lang="scss">
.custom-slider {
  display: flex;
}
.asset-lightbox-modal {
  .modal-content {
    left: 0;
    .masonry-thumbnail {
      padding-top: 24px;
      &:focus-visible{
        outline: none;
      }
      .carousel__track {
        height: 50px;
        .carousel__slide {
          padding-inline: 4px;
        }
        * {
          height: 100%;
        }
        img {
          object-fit: cover;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          cursor: pointer;
        }
      }
      
      &.notranslate {
        .carousel__track{
          transform: none !important;
          justify-content: center;
        }
      }
    }
  }
  .map-card-imgbanner{
    height: 100%;
  }
  .custom-slider-holder,
  .custom-slider,
  .custom-slider-slide {
    height: 100%;
  }
  .custom-slider-slide {
    display: flex;
    justify-content: center;
    width: 100%;
    flex-shrink: 0;
    img {
      max-height: 100%;
      max-width: 100%;
      object-fit: contain;
    }
  }

  .disabled-image-pointer {
    pointer-events: none;
  }
}
</style>
